<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/FV5PX/tc-custom/9781626812499.jpg?1734213798149" alt="This image is the cover for the book Never Let Them See You Cry"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Never Let Them See You Cry
      </h1>
      <p class="bookDescription body article font2">
        <b>True stories of crime in Miami by the Pulitzer Prize–winning author of <i>The Corpse Had a Familiar Face</i>.</b><br/>  <br/> Set against the neon backdrop of the South Florida city where <i>Miami Herald</i> reporter Edna Buchanan covered the police beat for nearly two decades, this memoir collects true tales of both heroes and villains—from the heartbreaking to the heartwarming to the outright hilarious.<br/>  <br/> “A flurry of cases—of criminal Christmases, historic crimes, homicidal love, cop heroes, rescuers, odd occurrences (such as that of the barbiturate-soaked gunman who took 26 direct hits from cops’ guns and kept shooting until a 27th round took him down) . . . a generous bonanza for crime buffs, presented by one of the sharpest writers in the field.” —<i>Kirkus Reviews</i>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Edna  Buchanan
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Diversion Books
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?1767f9a2